<template>
  <div class="main">
    <div class="b-nav">
      <img src="../assets/imgs/spec/icon_home.png" alt="">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/index' }">您当前所在的位置: 首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{article.category}}</el-breadcrumb-item>
        <el-breadcrumb-item><span class="title">
          {{article.title}}
        </span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="article-main">
      <div class="title">{{article.category}}</div>
      <div class="main-body">
        <div class="text-title">
          {{article.title}}
        </div>
        <div class="desc">
          <span>作者: {{article.author}}</span>
          <span>发布时间: {{article.release_time}}</span>
          <span>来源: {{article.source}}</span>
        </div>
<!--        <div class="ql-container ql-snow"><div class="main-text ql-editor" v-html="article.text"></div>-->
<!--          -->
<!--        </div>-->
        <div class="main-text" v-html="article.text"></div>
        <div class="p-end">
          <div class="line"></div>
          <div class="text-pagination">
            <span class="p-1" v-if="article.prev_article" @click="toArticle(article.prev_article.id)">上一篇：{{article.prev_article.title}}</span>
            <span class="p-3" v-else>上一篇：没有了</span>
            <span class="p-2" v-if="article.next_article" @click="toArticle(article.next_article.id)">下一篇：{{article.next_article.title}}</span>
            <span class="p-4" v-else>下一篇：没有了</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { pbInfo } from "../api";

  export default {
    name: "SpecificArticle",
    data() {
      return {
        id: '',
        article: {},
      }
    },
    methods: {
      getData() {
        const query = {id: this.id}
        pbInfo(null,query).then(res=> {
          if(res.code === 1000) {
            // console.log(res);
            this.article = res.data
          }
        })
      },
      toArticle(id) {
        this.$router.push({
          name: 'SpecificArticle',
          query: {ArticleId: id}
        })
      }
    },
    created() {

      this.id = this.$route.query.ArticleId
      this.getData()
    },
    mounted() {
      const mainText = document.querySelector('.main-text')
      const config = {  childList: true };
      const observer = new MutationObserver(() => {
        const imgs = mainText.querySelectorAll('img')
        imgs.forEach((img) => {
          const currentWidth = img.getBoundingClientRect().width
          img.style.height = currentWidth * (img.style.height.replace('px', '')) / (img.style.width.replace('px', '')) + 'px'
        })
      })
      observer.observe(mainText, config)
      // if (mainText) {
      //   setTimeout(()=> {
      //     const imgs = mainText.querySelectorAll('img')
      //     console.log(imgs);
      //     imgs.forEach((img) => {
      //       const currentWidth = img.getBoundingClientRect().width
      //       console.log(img.style.height);
      //       img.style.height = currentWidth * img.style.height / img.style.width
      //       console.log(img.style.height);
      //     })
      //   }, 2000)
      // }
    },
    watch: {
      $route: {
        handler: function(val){
          this.id = val.query.ArticleId
          this.getData()
          window.scroll(0, 0);
        },
        deep: true
      },
      // mainText: {
      //   handler: function (val) {
      //     console.log(val);
      //     if (!val) return
      //     const imgs = val.querySelectorAll('img')
      //     console.log(imgs);
      //     if (imgs && imgs.length) {
      //       console.log(imgs);
      //     }
      //   },
      //   immediate: true,
      //   deep: true
      // }
    }
  }
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 50px auto 0;
  .b-nav {
    width: 670px;
    height: 16px;
    display: flex;
    align-items: center;
    font-size: 16px;
    .el-breadcrumb {
      margin-left: 10px;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 16px;
      letter-spacing: 0;
      color: #656565;
      ::v-deep .is-link {
        font-weight: normal;
        color: #656565;
      }
    }
    img {
      width: 15px;
      height: 16px;
    }
    .title {
      width: 320px;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
  .article-main {
    width: 100%;
    display: flex;
    margin-top: 30px;
    min-height: 600px;
    margin-bottom: 20px;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #f9f9f9;
    border: solid 1px #d9d9d9;
    border-top: solid 2px #d43e42;
    .title {
      width: 958px;
      height: 40px;
      line-height: 40px;
      font-family: 'SourceHanSerifCN-Bold';
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0;
      color: #d43e42;
      border-bottom: solid 1px #d9d9d9;
    }
    .main-body {
      width: 840px;
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      min-height: 600px;
      .text-title {
        text-align: center;
        width: 100%;
        font-family: 'SourceHanSerifCN-Bold';
        font-size: 25px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0;
        color: #282828;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .desc {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        min-width: 360px;
        justify-content: space-between;
        span {
          font-family: 'SourceHanSansCN-Regular';
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0;
          color: #656565;
        }
      }
      .p-end {
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: auto;
        margin-bottom: 30px;
        .line {
          width: 840px;
          height: 1px;
          background-color: #d9d9d9;
        }
        .text-pagination {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-self: flex-end;
          margin-top: 12px;
          .p-1 {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            max-width: 250px;
            font-family: 'SourceHanSansCN-Regular';
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0;
            color: #656565;
            &:hover {
              cursor: pointer;
              color: #d43e42;
            }
          }
          .p-2 {
            max-width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            font-family: 'SourceHanSansCN-Regular';
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0;
            color: #656565;
            &:hover {
              cursor: pointer;
              color: #d43e42;
            }
          }
          .p-3 .p-4 {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            font-family: 'SourceHanSansCN-Regular';
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0;
            color: #f3efef;
          }
        }
      }
      .main-text {
        margin-top: 40px;
        width: 780px;
        margin-bottom: 220px;
        font-family: Alibaba-PuHuiTi-R;
        /*font-size: 16px;*/
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0;
        color: #282828;
        white-space: pre-wrap;
        line-height: 25px;
        ::v-deep img {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
